module.exports = __webpack_public_path__ + "img/bc-logo.f3ac1d58.jpg";